'use client';

import type { FC, HTMLAttributes } from 'react';
import React, { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';

import { cn } from '@/lib/utils';
import { useCssDimensions } from '@/utils/hooks/useCssDimensions';

import DesktopNavigation from '@/components/organisms/Navigation/components/desktop/DesktopNavigation';
import MobileNavigation from '@/components/organisms/Navigation/components/mobile/MobileNavigation';
import type { NavigationConfigType } from '@/components/organisms/Navigation/Navigation.types';
import { navigationRef } from '@/components/organisms/Navigation/utils/navigationRef';

export interface NavigationProps extends HTMLAttributes<HTMLDivElement> {
    config: NavigationConfigType;
}

const Navigation: FC<NavigationProps> = ({ config }) => {
    const location = usePathname();
    const [isPageOnTop, setIsPageOnTop] = useState<boolean>(true);
    // const showNavigation = useStickyNavigation();

    useEffect(() => {
        const handleYOffset = () => {
            !window.scrollY !== isPageOnTop && setIsPageOnTop(!window.scrollY);
        };

        window.addEventListener('scroll', handleYOffset);

        return () => window.removeEventListener('scroll', handleYOffset);
    }, [isPageOnTop]);

    const { minWidthXl } = useCssDimensions();

    return (
        <div
            ref={navigationRef}
            className={cn(
                'font-secondary w-full bg-background py-2 transition-[all] duration-500 md:static md:py-4 xl:py-8',
                // 'md:translate-y-0 md:static'
                !isPageOnTop && 'border-b border-grey-100 xl:py-4',
                // 'sticky translate-y-[-100vh] transition-[all] duration-500'
                // showNavigation && 'static translate-y-0',
            )}
        >
            {minWidthXl ? (
                <DesktopNavigation
                    className="hidden xl:flex"
                    location={location}
                    {...config}
                />
            ) : (
                <MobileNavigation
                    className="flex xl:hidden"
                    location={location}
                    {...config}
                />
            )}
        </div>
    );
};

export default Navigation;
